import { Layout } from "antd";
import styled from "styled-components";

import breakpoints from "@/constants/breakpoints";

import { SIDEBAR_COLLAPSED_WIDTH, SIDEBAR_WIDTH } from "./MainLayout.constants";

export const ContainerLayout = styled(Layout)`
  min-height: 100vh;
`;

export const ContentLayout = styled(Layout)<{ $isSidebarCollapsed: boolean }>`
    padding: 24px 32px 32px;
    margin-left: ${props => props.$isSidebarCollapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH}px;

    @media ${breakpoints.xs} {
      padding: 12px 16px 16px;
      margin-left: 0;
    }
`;
